<template>
  <div>
    <v-container grid-list-xs>
      <v-tabs
        color="black"
        slider-color="black"
        class="my-3"
        center-active
        hide-slider
      >
        <v-tab
          v-for="(v, i) in tag_list"
          :key="i"
          @click="scroll(`${v.name}`)"
          class="px-2"
          ><v-card
            class="py-3 px-8 rounded-pill"
            color="greener white--text"
            v-if="v.name == first"
          >
            {{ stripTagNumbering(v.name) }}
          </v-card>
          <v-card class="py-3 px-8 rounded-pill" v-else>
            {{ stripTagNumbering(v.name) }}
          </v-card>
        </v-tab>
      </v-tabs>
      <p
        class="text-center mt-10"
        v-if="franchise.custom_message && franchise.custom_message !== ''"
      >
        {{ franchise.custom_message }}
      </p>
      <div v-for="(value, index) in tag_list" :key="index">
        <h2 class="nunito mb-6 font-weight-bold leaf--text">
          {{ stripTagNumbering(value.name) }}
        </h2>
        <v-row :ref="value.name">
          <v-slide-group class="pa-4" show-arrows="always">
            <v-slide-item v-for="(v, i) in prod_for(value)" :key="i">
              <v-card
                flat
                class="mb-3 mr-3 ml-3"
                @click="selectProduct(v)"
                :disabled="v.total_left == 0 || v.out_of_stock ? true : false"
              >
                <v-img
                  height="200px"
                  max-width="200px"
                  class="rounded-lg"
                  v-if="v.media_urls.length > 0"
                  :src="image(v.media_urls[0])"
                ></v-img>
                <v-img
                  v-else
                  height="200px"
                  max-width="200px"
                  class="rounded-lg"
                  :src="emptyImage()"
                ></v-img>
                <div class="text-center nunito py-3">
                  <h3>
                    <b>{{ v.name }}</b>
                  </h3>
                  <div class="flex justify-center">
                    <h5
                      class="lato font-weight-bold font-italic red--text"
                      v-if="v.total_left == 0 || v.out_of_stock"
                    >
                      Sold Out
                    </h5>
                    <div v-else class="flex justify-center">
                      <h5
                        class="lato font-weight-bold ml-1"
                        v-if="v.price_type == 0"
                      >
                        <div v-if="v.variants.length > 1">
                          <div v-for="(vars, index) in v.variants" :key="index">
                            {{
                              vars.default == true
                                ? "RM" + currency(vars.price)
                                : ""
                            }}
                          </div>
                        </div>
                        <div v-else>RM {{ currency(v.unit_price) }}</div>
                      </h5>
                      <h5
                        class="lato font-weight-bold ml-1"
                        v-else-if="v.price_type == 1"
                      >
                        RM {{ currency(v.unit_price) }}
                      </h5>
                      <h5 class="lato font-weight-bold ml-1" v-else>
                        RM {{ currency(v.unit_price) }}
                      </h5>
                      <h5
                        class="lato font-weight-bold ml-2 grey--text line-through"
                        v-if="v.before_discount"
                      >
                        RM {{ currency(v.before_discount) }}
                      </h5>
                    </div>
                  </div>
                </div>
              </v-card>
            </v-slide-item>
          </v-slide-group>
        </v-row>
      </div>
    </v-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "slide",

  data() {
    return {
      first: null,
    };
  },

  computed: {
    ...mapGetters({
      product: "getProduct",
      cart: "getCart",
      franchise: "getFranchise",
      isTagCurrentlyActive: "isTagCurrentlyActive",
    }),

    currency() {
      return require("currency.js");
    },

    tag_list() {
      var tags = {};
      const isTagActive = this.isTagCurrentlyActive;
      // Only show tags where hidden_tag=0, hidden_product=0, AND tag is currently active (per-tag time)
      if (this.product && Array.isArray(this.product) && isTagActive) {
        this.product.forEach((prod) => {
          if (prod.tags && Array.isArray(prod.tags)) {
            prod.tags.forEach((tag) => {
              const isHiddenTag =
                tag.hidden_tag === true || tag.hidden_tag === 1;
              const isHiddenProduct =
                tag.hidden_product === true ||
                tag.hidden_product === 1 ||
                tag.hidden_products === true ||
                tag.hidden_products === 1;
              if (!isHiddenTag && !isHiddenProduct && isTagActive(tag)) {
                return (tags[tag.id] = tag);
              }
            });
          }
        });
      }
      return Object.values(tags).sort(function (a, b) {
        // Respect order_column first, then by name
        const aOrder = a.order_column != null ? a.order_column : 0;
        const bOrder = b.order_column != null ? b.order_column : 0;
        if (aOrder !== bOrder) return aOrder - bOrder;
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });
    },
  },

  watch: {
    // Watch for changes in product data to ensure tag_list updates
    product: {
      handler(newProducts) {
        if (newProducts && Array.isArray(newProducts)) {
          // Force reactivity update for tag_list
          this.$forceUpdate();
        }
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    stripTagNumbering(tagName) {
      // Strip numbering pattern like "01. ", "1. ", "01.", "1." from the start
      return tagName.replace(/^\d+\.\s*/, "");
    },
    image(i) {
      if (i.s512) {
        return i.s512;
      } else
        return (
          "https://s3-ap-southeast-1.amazonaws.com/assets.getorders/" +
          i.original
        );
    },
    emptyImage() {
      return (
        "https://s3-ap-southeast-1.amazonaws.com/assets.getorders/" +
        this.franchise.logo
      );
    },

    selectProduct(i) {
      this.$store.commit("setScrollPosition", window.pageYOffset);
      this.$store.dispatch("updateSP", i);
      this.track(i.name);
      this.$router.push({
        name: "Page",
        params: { child: this.$route.params.child, page: "product" },
      });
    },

    track(val) {
      this.$gtag.event("view_product", {
        event_category: "view_product",
        event_label: "view_product",
        value: val,
      });
    },

    scroll(refName) {
      this.first = refName;
      var element = this.$refs[refName];

      var top = element[0].offsetTop;
      window.scrollTo(0, top);
    },

    prod_for(tag) {
      // Add safety check to ensure product is an array
      if (!this.product || !Array.isArray(this.product)) {
        return [];
      }
      // Product must belong to tag; check hidden_product; AND tag must be currently active (per-tag time availability)
      const tagActive = this.isTagCurrentlyActive && this.isTagCurrentlyActive(tag);
      if (!tagActive) return [];
      var list = this.product.filter(
        (prod) =>
          prod.tags &&
          prod.tags.some((t) => {
            if (t.id !== tag.id) return false;
            const hidden =
              t.hidden_product === true ||
              t.hidden_product === 1 ||
              t.hidden_products === true ||
              t.hidden_products === 1;
            return !hidden;
          })
      );
      var priority_list = [
        ...list.filter((p) => p.media_urls.length > 0),
        ...list.filter((p) => p.media_urls.length == 0),
      ];

      // Sort by priority first (if exists)
      priority_list = priority_list.sort(function (a, b) {
        return (a.priority || 0) - (b.priority || 0);
      });

      // Then sort by product code/name according to requirements
      priority_list = priority_list.sort(function (a, b) {
        const aHasCode = a.code && a.code.trim() !== "";
        const bHasCode = b.code && b.code.trim() !== "";

        // If both have codes, sort by code (numeric-aware)
        if (aHasCode && bHasCode) {
          return a.code.localeCompare(b.code, undefined, {
            numeric: true,
            sensitivity: "base",
          });
        }

        // If only a has code, a comes first
        if (aHasCode && !bHasCode) {
          return -1;
        }

        // If only b has code, b comes first
        if (!aHasCode && bHasCode) {
          return 1;
        }

        // If neither has code, sort by name
        const aName = a.name || "";
        const bName = b.name || "";
        return aName.localeCompare(bName, undefined, { sensitivity: "base" });
      });

      return priority_list;
    },
  },

  mounted() {
    // console.log(this.product)
    console.log("slide");
    // this.scroll(this.tag_list[0].name);
    if (this.tag_list.length > 0) {
      this.first = this.tag_list[0].name;
    }
  },
};
</script>
<style>
.elipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.height {
  height: 100%;
}
.greener {
  background-color: #279474 !important;
}
.line-through {
  text-decoration: line-through red;
}
</style>
